const styles = {
  bottomContainer: {
    alignItems: "flex-start",
    borderTop: "solid 1px rgb(223, 229, 233)",
    color: "rgb(51, 51, 51)",
    display: "flex",
    flex: 1,
    flexDirection: "column",
    fontSize: 12.5,
    justifyContent: "space-between",
    lineHeight: "20px",
    paddingTop: 14
  },
  buttonContainer: {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    fontSize: 18,
    fontWeight: 300,
    justifyContent: "space-between",
    lineHeight: "20px",
    width: "100%"
  },
  container: {
    border: "solid 1px rgb(223, 229, 233)",
    boxSizing: "border-box",
    display: "flex",
    flex: 1,
    flexDirection: "column",
    fontSize: 11,
    minHeight: 165,
    padding: 16,
    margin: "10px 5px",
    maxWidth: 265,
    minWidth: 265
  },
  description: {
    marginBottom: 15
  },
  mainDescription: {
    alignItems: "center",
    color: "rgb(33, 194, 248)",
    display: "flex",
    fontSize: 18,
    fontWeight: 300,
    lineHeight: "20px",
    marginBottom: 6,
    marginTop: 6
  },
  subTitle: {
    color: "rgb(154, 167, 175)",
    fontSize: 13,
    fontWeight: 300,
    lineHeight: "19px"
  },
  textarea: {
    backgroundColor: "transparent",
    border: "none",
    boxShadow: "none",
    fontSize: 16,
    outline: "none",
    overflow: "auto",
    resize: "none"
  },
  title: {
    color: "rgb(47, 56, 61)",
    fontSize: 15,
    fontWeight: 300,
    lineHeight: "19px"
  }
};

export default styles;
